@if (showInfoLink) {
  <div class="wrapper">
    <a href="{{infoLink}}" target="_blank">{{ "MORE.INFO.PRECIOUSMETAL" | translate }}</a>
  </div>
}